import { api } from "./api";
import {
  accessoriesSlice,
  dimensionsSlice,
  edgesSlice,
  holesSlice,
  measurementsSlice,
  sinkSlice,
  cartSlice,
} from "./slices";

export const reducer = {
  [api.reducerPath]: api.reducer,
  dimensions: dimensionsSlice.reducer,
  sinks: sinkSlice.reducer,
  holes: holesSlice.reducer,
  edges: edgesSlice.reducer,
  accessories: accessoriesSlice.reducer,
  measurements: measurementsSlice.reducer,
  cart: cartSlice.reducer,
};
